import React from "react";
import {
  Box,
  Container,
  Typography,
  Grid
} from "@mui/material";
import AboutInfo from "../components/AboutInfo";
import FeatureSection from "../components/FeatureSection";
import BestDeals from "../components/BestDeals";

const Aboutus = () => {


  return (
    <>
    <AboutInfo />
    <FeatureSection />
    <BestDeals />
    </>
  );
};

export default Aboutus;